import type { InjectionKey } from 'vue'
import {
  MeasureStatus,
  MeasureStatusAll,
  type Policy,
  type Perimeter,
} from '@/contexts/security-base-v2/SecurityBaseV2.interfaces'
import { NdsTagColor } from '@/components/NewDesignSystem/NdsTag/NdsTag.interfaces'
import type { NdsChipSelectors } from '@/components/NewDesignSystem/NdsChipSelector/NdsChipSelector.interfaces'
import { NdsChipState } from '@/components/NewDesignSystem/NdsChip/NdsChip.interfaces'

export const MEASURE_STATUS_TRANSLATION_KEY: Readonly<Record<MeasureStatus, string>> = {
  [MeasureStatus.TO_IMPLEMENT]: 'security_base_v2.measure.status.to_implement',
  [MeasureStatus.BEING_IMPLEMENTED]: 'security_base_v2.measure.status.being_implemented',
  [MeasureStatus.IMPLEMENTED]: 'security_base_v2.measure.status.implemented',
}

export const MEASURE_STATUS_TAG_COLOR: Readonly<Record<MeasureStatus, NdsTagColor>> = {
  [MeasureStatus.TO_IMPLEMENT]: NdsTagColor.NEUTRAL,
  [MeasureStatus.BEING_IMPLEMENTED]: NdsTagColor.WARNING,
  [MeasureStatus.IMPLEMENTED]: NdsTagColor.SUCCESS,
}

export const MEASURES_FILTERS: Readonly<NdsChipSelectors> = [
  {
    id: MeasureStatusAll.ALL,
    labelKey: 'security_base_v2.measure.status.all',
    counter: 13,
  },
  {
    id: MeasureStatus.TO_IMPLEMENT,
    labelKey: MEASURE_STATUS_TRANSLATION_KEY[MeasureStatus.TO_IMPLEMENT],
    counter: 4,
    state: NdsChipState.NEUTRAL,
  },
  {
    id: MeasureStatus.BEING_IMPLEMENTED,
    labelKey: MEASURE_STATUS_TRANSLATION_KEY[MeasureStatus.BEING_IMPLEMENTED],
    counter: 3,
    state: NdsChipState.WARNING,
  },
  {
    id: MeasureStatus.IMPLEMENTED,
    labelKey: MEASURE_STATUS_TRANSLATION_KEY[MeasureStatus.IMPLEMENTED],
    counter: 3,
    state: NdsChipState.SUCCESS,
  },
]

export const OPEN_REMOVE_POLICY_MODAL_KEY: InjectionKey<(policy: Policy) => void> = Symbol('openRemovePolicyModal')
export const SELECT_PERIMETER_KEY: InjectionKey<(perimeter: Perimeter) => void> = Symbol('selectPerimeter')
export const UNSELECT_PERIMETER_KEY: InjectionKey<(perimeter: Perimeter) => void> = Symbol('unselectPerimeter')

export enum SecurityBaseV2Route {
  ROUTING = 'security_base_v2_routing',
  MEASURES_LIST = 'security_base_v2_measures_list',
  PERIMETERS = 'security_base_v2_perimeters',
  POLICIES = 'security_base_v2_policies',
}

export enum OldSecurityBaseRoute {
  MAIN = 'security_base',
  MEASURES_DIFF = 'measures_diff',
}
